<template>
  <datepicker
    :format="format"
    placeholder="Select Date"
    v-model="vModelExample"
    @selected="dateSelect"
  ></datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import DateLanguages from './utils/DateLanguages';
import moment from 'moment';
const state = {
  date1: new Date(),
};

export default {
  name: 'dobPicker',
  props:['preSelectDob'],
  components: {
    Datepicker,
  },
  computed:{
    preSelectComputed:{
      get: function () {
        // return this.newselectedValueOption
      return this.preSelectDob
      },
      set: function (newValue) {
        // this.newselectedValue   = newValue
         this.$emit('selectedDate', moment(newValue).format('YYYY-MM-DD'));
        
      }
    }
    },
  data() {
    return {
      format: 'yyyy-MM-dd',
      disabled: {},
      disabledFn: {
        customPredictor(date) {
          if (date.getDate() % 3 === 0) {
            return true;
          }
        },
      },
      highlightedFn: {
        customPredictor(date) {
          if (date.getDate() % 4 === 0) {
            return true;
          }
        },
      },
      highlighted: {},
      eventMsg: null,
      state: state,
      language: 'en',
      languages: DateLanguages.translations,
      vModelExample: null,
    };
  },
  created(){
    this.vModelExample = this.preSelectDob
  },
  methods: {
    dateSelect(date) {
      this.preSelectComputed = date
      // this.$emit('selectedDate', moment(date).format('YYYY-MM-DD'));
    },
  },
  watch:{
    preSelectDob:function(newVal, oldVal){
      this.vModelExample = this.preSelectComputed
    }
  }
};
</script>

